import PropTypes from "prop-types";

import { userObject } from "./user.js";
import { dynamicObject } from "./dynamic.object.js";

const sandboxObject = PropTypes.shape({
  _id: PropTypes.string,
  Name: PropTypes.string,
  Type: PropTypes.string
});

const PROP_TYPES = {
  ...PropTypes,
  userObject,
  dynamicObject,
  sandboxObject
};

export default PROP_TYPES;
